var __jsx = React.createElement;
import React, { Fragment } from 'react';
import styled from 'styled-components';
import styles from './FooterV2.style';
import _Logo from './Areas/Logo';
import _MainMenu from './Areas/MainMenu';
import _CTAMenu from './Areas/CTAMenu';
import _UtilityMenu from './Areas/UtilityMenu';
import _ContactInformation from './Areas/ContactInformation';
import _SocialMedia from './Areas/SocialMedia';
import HoursOfOperationArea from './Areas/HoursOfOperationArea';
import _Copyright from './Areas/Copyright';
import _ImageContent from './Areas/ImageContent';
var componentsMap = {
  'Logo': function Logo(props) {
    return __jsx(_Logo, {
      footerLogo: props.footerLogo
    });
  },
  'CTA Menu': function CTAMenu(props) {
    return __jsx(_CTAMenu, {
      ctaMenuCollection: props.footer.ctaMenuCollection,
      openDropdownOnClick: true
    });
  },
  'Main Menu': function MainMenu(props) {
    return __jsx(_MainMenu, {
      mainMenuCollection: props.footer.mainMenuCollection,
      openDropdownOnClick: true
    });
  },
  'Utility Menu': function UtilityMenu(props) {
    return __jsx(_UtilityMenu, {
      items: props.footer.utilityMenuCollection.items
    });
  },
  'Contact Information': function ContactInformation(props) {
    return __jsx(_ContactInformation, {
      items: props.footer.contactInformationCollection.items,
      yextContactInformationData: props.yextContactInformationData
    });
  },
  'Social Media': function SocialMedia(props) {
    return __jsx(_SocialMedia, {
      socialMedia: props.footer.socialMedia,
      siteName: props.siteName
    });
  },
  'Hours of Operation': function HoursOfOperation(props) {
    return __jsx(HoursOfOperationArea, {
      yextContactInformationData: props.yextContactInformationData
    });
  },
  'Divider': function Divider() {
    return __jsx("span", {
      className: "nva-footer__divider"
    });
  },
  'Copyright': function Copyright() {
    return __jsx(_Copyright, null);
  },
  'Image Content': function ImageContent(props) {
    return __jsx(_ImageContent, {
      imageContentCollection: props.footer.imageContentCollection.items
    });
  }
};
var FooterItem = function FooterItem(props) {
  var _componentsMap$props$;
  return (_componentsMap$props$ = componentsMap[props.component]) === null || _componentsMap$props$ === void 0 ? void 0 : _componentsMap$props$.call(componentsMap, props);
};
var FooterV2 = function FooterV2(_ref) {
  var _footer$logicalOrderD, _footer$logicalOrderD2, _footer$logicalOrderM, _footer$logicalOrderM2;
  var className = _ref.className,
    footer = _ref.footer,
    yextContactInformationData = _ref.yextContactInformationData,
    footerLogo = _ref.footerLogo,
    siteName = _ref.siteName;
  var logicalOrderDesktop = footer === null || footer === void 0 ? void 0 : (_footer$logicalOrderD = footer.logicalOrderDesktop) === null || _footer$logicalOrderD === void 0 ? void 0 : (_footer$logicalOrderD2 = _footer$logicalOrderD.areasCollection) === null || _footer$logicalOrderD2 === void 0 ? void 0 : _footer$logicalOrderD2.items;
  var logicalOrderMobile = footer === null || footer === void 0 ? void 0 : (_footer$logicalOrderM = footer.logicalOrderMobile) === null || _footer$logicalOrderM === void 0 ? void 0 : (_footer$logicalOrderM2 = _footer$logicalOrderM.areasCollection) === null || _footer$logicalOrderM2 === void 0 ? void 0 : _footer$logicalOrderM2.items;
  return __jsx("footer", {
    className: "nva-footer ".concat(className)
  }, __jsx("div", {
    className: "nva-footer__wrapper--desktop"
  }, __jsx("div", {
    className: "l-grid nva-footer__grid"
  }, logicalOrderDesktop === null || logicalOrderDesktop === void 0 ? void 0 : logicalOrderDesktop.map(function (component, index) {
    return __jsx(Fragment, {
      key: component.area + index
    }, __jsx(FooterItem, {
      component: component.area,
      footer: footer,
      yextContactInformationData: yextContactInformationData,
      footerLogo: footerLogo,
      siteName: siteName
    }));
  }))), __jsx("div", {
    className: "nva-footer__wrapper--mobile"
  }, __jsx("div", {
    className: "l-grid nva-footer__grid"
  }, logicalOrderMobile === null || logicalOrderMobile === void 0 ? void 0 : logicalOrderMobile.map(function (component, index) {
    return __jsx(Fragment, {
      key: component.area + index
    }, __jsx(FooterItem, {
      component: component.area,
      footer: footer,
      yextContactInformationData: yextContactInformationData,
      footerLogo: footerLogo,
      siteName: siteName
    }));
  }))));
};
export default styled( /*#__PURE__*/React.memo(FooterV2)).withConfig({
  componentId: "sc-10nr1gg-0"
})(["", ";"], styles);